import { useEffect, useId, useState } from "react";
import { Collapse } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const SECTION_TITLE_STYLE = {
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#5B6472",
};

function WorkspaceSettingsSection({
  title,
  defaultOpen = false,
  collapseSignal = 0,
  children,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  useEffect(() => {
    setIsOpen(false);
  }, [collapseSignal]);

  return (
    <div>
      <button
        type="button"
        className="btn w-100 d-flex align-items-center justify-content-between p-0 border-0 bg-transparent shadow-none text-start"
        onClick={() => setIsOpen((current) => !current)}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span style={SECTION_TITLE_STYLE}>{title}</span>
        <span style={{ color: "#5B6472", fontSize: "0.75rem" }}>
          {isOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
        </span>
      </button>

      <Collapse in={isOpen}>
        <div id={contentId} className="pt-2">
          {children}
        </div>
      </Collapse>
    </div>
  );
}

export default WorkspaceSettingsSection;
